import { AxiosService } from './axiosService';

export class ComponentService extends AxiosService {
    // A non-GUID parentId (e.g. "root") makes the API return the root components.
    async getComponentRoots() {
        return this.getComponentChildren('root');
    }

    async getComponentChildren(parentId) {
        try {
            const { data } = await this.axios.get('/componentChildren', { params: { parentId } });
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) throw e;
        }
        return null;
    }

    async getComponentDetails(id) {
        try {
            const { data } = await this.axios.get('/componentmanager/component', {
                params: { id },
            });
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) throw e;
        }
        return null;
    }

    async createComponent(payload) {
        try {
            const { data } = await this.axios.post('/componentmanager/component', payload);
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) throw e;
        }
        return null;
    }

    async updateComponentDetails(payload) {
        try {
            const { data } = await this.axios.put('/componentmanager/component', payload);
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) throw e;
        }
        return null;
    }

    async getComponentDeleteImpact(id) {
        try {
            const { data } = await this.axios.get('/componentmanager/component/deleteimpact', {
                params: { id },
            });
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) throw e;
        }
        return null;
    }

    async deleteComponent(id) {
        try {
            const { data } = await this.axios.delete(`/componentmanager/component/${id}`);
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) throw e;
        }
        return null;
    }

    async getComponentTypes() {
        try {
            const { data } = await this.axios.get('/componentmanager/componenttypes');
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) throw e;
        }
        return null;
    }

    async getComponentPoints(componentId) {
        try {
            const { data } = await this.axios.get('/componentmanager/points', {
                params: { componentId },
            });
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) throw e;
        }
        return null;
    }

    async setComponentPoints(componentId, genericPointIds) {
        try {
            const { data } = await this.axios.post('/componentmanager/points', {
                componentId,
                genericPointIds,
            });
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) throw e;
        }
        return null;
    }
    
    async deleteComponentPoint(componentPointId) {
        try {
            const { data } = await this.axios.delete('/componentmanager/points', {
                params: { componentPointId },
            });
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) throw e;
        }
        return null;
    }

    async moveComponentPoint(componentPointId, newComponentId) {
        try {
            const { data } = await this.axios.post('/componentmanager/points/move', {
                componentPointId,
                newComponentId,
            });
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) throw e;
        }
        return null;
    }

    async getGenericPoints({ pageSize, pageIndex, sortBy, orderBy, search, pointType } = {}) {
        try {
            const params = {};
            if (pageSize != null) params.pageSize = pageSize;
            if (pageIndex != null) params.pageIndex = pageIndex;
            if (sortBy) params.sortBy = sortBy;
            if (orderBy) params.orderBy = orderBy;
            if (search) params.search = search;
            if (pointType) params.pointType = pointType;
            const { data } = await this.axios.get('/componentmanager/genericpoints', { params });
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) throw e;
        }
        return null;
    }

    async getComponentFunctions(componentId) {
        try {
            const { data } = await this.axios.get('/componentmanager/functions', {
                params: { componentId },
            });
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) throw e;
        }
        return null;
    }

    async setComponentFunctions(componentId, functionIds) {
        try {
            const { data } = await this.axios.post('/componentmanager/functions', {
                componentId,
                functionIds,
            });
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) throw e;
        }
        return null;
    }

    async getFunctions({ includeHidden } = {}) {
        try {
            const params = {};
            if (includeHidden != null) params.includeHidden = includeHidden;
            const { data } = await this.axios.get('/componentmanager/functions/library', { params });
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) throw e;
        }
        return null;
    }

    async getPointDependents(componentPointIds) {
        try {
            const ids = Array.isArray(componentPointIds)
                ? componentPointIds.join(',')
                : componentPointIds;
            const { data } = await this.axios.get('/componentmanager/points/dependents', {
                params: { componentPointId: ids },
            });
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) throw e;
        }
        return null;
    }
}

export const componentService = new ComponentService();
